module.exports = __webpack_public_path__ + "img/as-service.65be07e6.jpg";